import React,{Fragment,useRef,useState,useEffect} from 'react';
import classes from './Customer.module.css';
import axios from "axios";
import {GoogleMap,LoadScript,Marker} from '@react-google-maps/api'; 
import BottomBgm from '../../assets/bottom_right.png';
import VerifyIcon from '../../assets/correct.png';
import useGeoLocation from '../../hooks/useGeoLocation';
import S3FileUpload from 'react-s3';
import { Buffer } from 'buffer';
import usePlacesAutocomplete, {
	getGeocode,
	getLatLng,
  } from "use-places-autocomplete";
  import useOnclickOutside from "react-cool-onclickoutside";
import OTPInput, { ResendOTP } from "otp-input-react";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Cookies from 'js-cookie';
import AuthLogo from '../../assets/authentication.jpg';

const containerStyle = {
  width: "100%",
  height: "190px",
};
// const API_URL = "http://demo.autozilla.co/";
// const S3_BUCKET_NAME = "az-dev-images-azvpc";

// const API_URL = "https://preprod.autozilla.co/";
// const S3_BUCKET_NAME = "az-uat-images-azvpc";

const API_URL = "https://app.autozilla.co/";
const S3_BUCKET_NAME = "az-prd-images-azvpc";

const CustomerForm = props =>{
	const stateData = [];
	const cityData = [];
	const [map, setMap] = useState(null);
	const [currentLoc, setCurrentLoc] = useState({lat: '17.4357012',lng: '78.3599279'});
	const [bodyWorks,SetBodyWorks] = useState('No');
	const [garageOil,SetGarageOil] = useState('No');
	//const [oilCompanies,SetOilCompanies] = useState('');
	//const [paintCompanies,SetPaintCompanies] = useState('');
	const [OTP, setOTP] = useState("");
	const [showOtpInput,SetShowOtpInput] = useState(false);
	const [otpSent,SetOtpSent] =  useState('');
	const [mobileVerified,SetMobileVerified] = useState(false);
	const [mobileValid,SetMobileValid] = useState(true);
	const [otpMatched,SetOtpMatched] = useState(true); 
	//const [gstNo,SetGstNo] = useState('');
	//const [sparePurVal,SetsparePurVal] = useState('');
	//const [noCarsVal,SetnoCarsVal] = useState('');
	//const [mobileNo,SetMobileNo] = useState('');
	const [customerExist,SetCustomerExist] = useState(false);
	const [gstExist,SetGstExist] = useState(false);
	//const [managerShare,SetManagerShare] = useState(0);
	//const [postcode,SetPostcode] = useState('');
	//const [appendAddress,SetAppendAddress] = useState('');
	
	const [formData, setFormData] = useState({
        id:  0,
        garage_Name: "",
		emailId:"",
		gstNo:"",
		owner_Name:"",
		manager_Name:"",
		manager_Phone:"",
		mobileNo:"",
		appendAddress:"",
		land_Mark:"",
		cityId:0,
		stateId:0,
		postcode:"",
		garage_Area:"",
		bays_Number:"",
		noCarsVal:"",
		oil_Consumption:"",
		sparePurVal:"",			
		oilCompanies:"",
		paintCompanies:"",
		owner_Share:100,
		managerShare:0

    });

	//console.log(garageOil);
	
	window.Buffer = window.Buffer || require("buffer").Buffer;
	//const location  = useGeoLocation();
	//console.log(Cookies.get());
	//console.log(Cookies.get('END_DATE'));
	useEffect(() => {
		navigator.geolocation.getCurrentPosition((position) => {
			 setCurrentLoc({
			   lat: position.coords.latitude,
			   lng: position.coords.longitude,
			 });
			 formattedAddress(position.coords.latitude,position.coords.longitude);		
		});
	},[]);
	const enteredOilCompanyHandler = (e)=>{
		//console.log(e.target.value);
		//SetOilCompanies(e.target.value);
		setFormData({...formData,oilCompanies:e.target.value});
	}
	const PaintCompanyHandler = (e)=>{
		//console.log(e.target.value);
		//SetPaintCompanies(e.target.value);
		setFormData({...formData,paintCompanies:e.target.value});
	}
	//console.log(currentLoc);
	//const [isValid,SetIsValid] = useState(true);
	const [pictures,setPictures] = useState([]);
	const [states,SetStates] = useState(stateData);
	const [cities,SetCities] = useState(cityData);
	const [errors,SetErrors] = useState(
	{
		garageNameError : false,
		emailError:false,			
		gstNumberError:false,
		ownerNameError:false,
		ownerMobileError : false,
		addressError:false,
		stateError:false,
		cityError:false,
		zipError:false,	
	}
	);
	
	
	const enteredGarageName = useRef();	
	const enteredOwnerName = useRef();
	const enteredEmail = useRef();
	const enteredMobile = useRef();
	const enteredManagerName = useRef();
	const enteredManagerMobile = useRef();
	const enteredAddress = useRef();	
	const enteredGstNo = useRef();
	const enteredCity = useRef();
	const enteredState = useRef();
	const enteredCountry = useRef();
	const enteredZipcode = useRef();
	const enteredGeocode = useRef();
	const enteredGarageArea = useRef();
	const enteredBays = useRef();
	const enteredCars = useRef();
	const enteredOilConsumption = useRef();
	const enteredSparePurchase = useRef();
	//const enteredOilCompany = useRef();
	//const enteredPaintCompany = useRef();
	const enteredOwnerShare = useRef();
	const enteredManagerShare = useRef();
	const enteredLandMark = useRef();
	
	useEffect(() => {
	axios.get(API_URL+'pos/api/States',{
      auth: {
        username: 'az_live@autozilla.com',
        password: '4cslC166sb2A63FmO7Jh65z0N3Zh1ZL8'
      }
    })
    .then(res => {
		const statesResp = res.data; 		
		SetStates(statesResp);
      
    });
	
    },[]);
	//console.log(states);
	const stateSelectHandler =(event,selection)=>{
		var selectedStateId = event.target.value;
		console.log(selection);
		if(selection!=''){
			selectedStateId = selection;
		}
		//console.log(selectedStateId);
		setFormData({...formData,stateId:event.target.value});
		axios.get(API_URL+'pos/api/Cities?state_id='+selectedStateId,{
		  auth: {
			username: 'az_live@autozilla.com',
			password: '4cslC166sb2A63FmO7Jh65z0N3Zh1ZL8'
		  }
		})
		.then(res => {
			const cityResp = res.data; 			
			SetCities(cityResp);	
			SetErrors({...errors, cityError: false});		  
		});
	}
	//const picturesArr = [];
	
	const filesSelectHandler = (event)=>{
		//console.log(event.target.files);
		const addedFile = event.target.files[0];
		setPictures((pictures) => [...pictures, addedFile]);
		//setPictures(picturesArr);	
	}
	const deleteImage = (index)=>{
		console.log(index);
		setPictures((pictures) => pictures.filter((item)=> item.name !== index));
	}
	
	//console.log(pictures);
	const bodyworksChangeHandler = (e)=>{
		SetBodyWorks(e.target.value);		
		//setFormData({...formData,bodyWorks:e.target.value});
		if(e.target.value==='No'){
			//SetPaintCompanies('');
			setFormData({...formData,paintCompanies:''});
		}
	}
	const garageOilChangeHandler = (e) =>{
		SetGarageOil(e.target.value);
		//setFormData({...formData,garage_Oil_Tie:e.target.value});
		if(e.target.value==='No'){
			//SetOilCompanies('');
			setFormData({...formData,oilCompanies:''});
		}
	}
		
	const validateHandler = (e)=>{
		if(e.target.name ==='garage_name'){
			SetErrors({...errors, garageNameError: false});
			setFormData({...formData,garage_Name:e.target.value});
		}
		if(e.target.name ==='email'){
			SetErrors({...errors, emailError: false});
			setFormData({...formData,emailId:e.target.value});
		}
		if(e.target.name ==='owner_name'){
			SetErrors({...errors, ownerNameError: false});
			setFormData({...formData,owner_Name:e.target.value});
		}
		if(e.target.name ==='zipcode'){
			const re = /^[0-9\b]+$/;
			if (e.target.value === '' || re.test(e.target.value)) {
				setFormData({...formData,postcode:e.target.value});
			}
			SetErrors({...errors, zipError: false});
		}
		
	}
	const citySelectHandler=(e,selection)=>{
		SetErrors({...errors, cityError: false});
		setFormData({...formData,cityId:e.target.value});
	}
	const addressChangeHandler =(e)=>{
		//SetAppendAddress(e.target.value);
		setFormData({...formData,appendAddress:e.target.value});
		//setValue(e.target.value);
		SetErrors({...errors, addressError: false});
	}
	const validateGstHandler=(e)=>{
		if(e.target.name ==='gstno'){
			setFormData({...formData,gstNo:e.target.value.toUpperCase().replace(/[^a-z0-9]/gi, '')});
			//SetGstNo(e.target.value.toUpperCase().replace(/[^a-z0-9]/gi, ''));	
			SetErrors({...errors, gstNumberError: false});
		}
		if(e.target.value.length===15){
			const gstJson = {
				gst_no : e.target.value
			}
			axios.post(API_URL+'pos/api/UserExist',gstJson,{
			   auth: {username:'az_live@autozilla.com',
					  password:'4cslC166sb2A63FmO7Jh65z0N3Zh1ZL8'},
			  headers : {           
				'Content-Type' : 'application/json'
			  }
			})
			.then(res => {
				if(res.data.id>0){
					SetGstExist(true);	
					//SetGstNo(res.data.gstno);
					stateSelectHandler(e,res.data.state_id);
					setFormData({...formData,
						garage_Name : res.data.account_name,
						emailId:res.data.email,
						gstNo:res.data.gstno,
						owner_Name:res.data.primary_contact_name,
						mobileNo:res.data.phone_number,	
						manager_Name:res.data.secondary_contact_name,
						manager_Phone:res.data.secondary_contact_phone,					
						appendAddress:res.data.address,
						land_Mark:res.data.land_mark,
						cityId:res.data.city_id,
						stateId:res.data.state_id,
						postcode:res.data.zipcode,
						garage_Area:res.data.garage_area,
						bays_Number:res.data.bays_count,
						noCarsVal:res.data.cars_per_month,
						oil_Consumption:res.data.oil_consumption,
						sparePurVal:res.data.spare_purchase,
						//bodyWorks:res.data.bodyworks_paint,
						//garage_Oil_Tie:res.data.garage_oil_tie,
						oilCompanies:res.data.oil_company,
						paintCompanies:res.data.painting_company,
						owner_Share:res.data.owner_share,
						managerShare:res.data.manager_share
					});		
					
					SetBodyWorks(res.data.bodyworks_paint);
					SetGarageOil(res.data.garage_oil_tie);
				}else{
					SetGstExist(false);	
					/*setFormData({...formData,
						garage_Name : '',
						emailId:'',
						gstNo:e.target.value,
						owner_Name:'',
						mobileNo:enteredMobile.current.value,
						manager_Name:'',
						manager_Phone:'',								
						appendAddress:'',
						land_Mark:'',
						cityId:'',
						stateId:'',
						postcode:'',
						garage_Area:'',
						bays_Number:'',
						noCarsVal:'',
						oil_Consumption:'',
						sparePurVal:'',
						bodyWorks:''
					});	*/
				}	  
			});	
		}else{
			SetGstExist(false);			
		}
	}
	const verifyButtonHandler =(e)=>{
		 e.preventDefault();		
		if(enteredMobile.current.value.length ===10){
			SetMobileValid(true);
			SetShowOtpInput(true);
			let randomOtp = (Math.floor(Math.random() * 10000) + 10000).toString().substring(1);
			//console.log(randomOtp);
			SetOtpSent(randomOtp);
			
			const otpJson = {
				mobile_number : enteredMobile.current.value,
				otp : randomOtp
			}
			
		axios.post(API_URL+'pos/api/SendOtp',otpJson,{
		   auth: {username:'az_live@autozilla.com',
                  password:'4cslC166sb2A63FmO7Jh65z0N3Zh1ZL8'},
		  headers : {           
            'Content-Type' : 'application/json'
			}
		})
		.then(res => {
			//console.log(res);	  
		});
			
			//console.log(enteredMobile.current.value);
		}else{
			SetMobileValid(false);
		}
	}
	
	const resendOTP = (e) => {
		
		if(enteredMobile.current.value.length ===10){
			SetMobileValid(true);
			SetShowOtpInput(true);
			let randomOtp = (Math.floor(Math.random() * 10000) + 10000).toString().substring(1);
			//console.log(randomOtp);
			SetOtpSent(randomOtp);
			
			const otpJson = {
				mobile_number : enteredMobile.current.value,
				otp : randomOtp
			}
			
		axios.post(API_URL+'pos/api/SendOtp',otpJson,{
		   auth: {username:'az_live@autozilla.com',
                  password:'4cslC166sb2A63FmO7Jh65z0N3Zh1ZL8'},
		  headers : {           
            'Content-Type' : 'application/json'
			}
		})
		.then(res => {
			//console.log(res);	  
		});
			
			//console.log(enteredMobile.current.value);
		}else{
			SetMobileValid(false);
		}
	  };
	
	const validateMobileNumber = (e)=>{
		const re = /^[0-9\b]+$/;
		if (e.target.value === '' || re.test(e.target.value)) {
         setFormData({...formData,mobileNo:e.target.value});
		}
		SetErrors({...errors, ownerMobileError: false});
		if(e.target.value.length===10){
			const mobileJson = {
				mobile : e.target.value
			}
			axios.post(API_URL+'pos/api/UserExist',mobileJson,{
			   auth: {username:'az_live@autozilla.com',
					  password:'4cslC166sb2A63FmO7Jh65z0N3Zh1ZL8'},
			  headers : {           
				'Content-Type' : 'application/json'
			  }
			})
			.then(res => {
				if(res.data.id>0){
					//console.log(res.data);
					SetCustomerExist(true);
					stateSelectHandler(e,res.data.state_id);					
					setFormData({...formData,
						garage_Name : res.data.account_name,
						emailId:res.data.email,
						gstNo:res.data.gstno,
						owner_Name:res.data.primary_contact_name,
						mobileNo:res.data.phone_number,	
						manager_Name:res.data.secondary_contact_name,
						manager_Phone:res.data.secondary_contact_phone,								
						appendAddress:res.data.address,
						land_Mark:res.data.land_mark,
						cityId:res.data.city_id,
						stateId:res.data.state_id,
						postcode:res.data.zipcode,
						garage_Area:res.data.garage_area,
						bays_Number:res.data.bays_count,
						noCarsVal:res.data.cars_per_month,
						oil_Consumption:res.data.oil_consumption,
						sparePurVal:res.data.spare_purchase,
						//bodyWorks:res.data.bodyworks_paint,
						//garage_Oil_Tie:res.data.garage_oil_tie,
						oilCompanies:res.data.oil_company,
						paintCompanies:res.data.painting_company,
						owner_Share:res.data.owner_share,
						managerShare:res.data.manager_share
					});	

					SetBodyWorks(res.data.bodyworks_paint);
					SetGarageOil(res.data.garage_oil_tie);
								
				}else{
					SetCustomerExist(false);
					/*setFormData({...formData,
						garage_Name : '',
						emailId:'',
						gstNo:enteredGstNo.current.value,
						owner_Name:'',
						mobileNo:e.target.value,
						manager_Name:'',
						manager_Phone:'',								
						appendAddress:'',
						land_Mark:'',
						cityId:'',
						stateId:'',
						postcode:'',
						garage_Area:'',
						bays_Number:'',
						noCarsVal:'',
						oil_Consumption:'',
						sparePurVal:'',
						bodyWorks:''
					});*/	
				}	  
			});	
			
			SetMobileValid(true);
		}else{
			SetMobileValid(false);
			SetCustomerExist(false);
		}

	}
	
	const verifyMobileHandler = (e)=>{
		 e.preventDefault();
		 //console.log(otpSent);
		 //console.log(OTP);
		 if(otpSent===OTP){
			SetMobileVerified(true);
			SetShowOtpInput(false);
			SetOtpMatched(true);
		 }else{
			SetMobileVerified(false);
			SetOtpMatched(false);
		 }
	}
	
	const ownerShareChangeHandler = (e)=>{
		
		if(e.target.value.trim().length>0){		
			//SetManagerShare(100-e.target.value);
			setFormData({...formData,owner_Share:e.target.value, managerShare:100-e.target.value});
		}else{
			setFormData({...formData,managerShare:0});
		}
	}

	//Location AutoSearch Starts Here!
	const {
		ready,
		value,
		suggestions: { status, data },
		setValue,
		clearSuggestions,
	  } = usePlacesAutocomplete({
		requestOptions: {
		  /* Define search scope here */
		  },
		debounce: 300,
	});
	  
	const ref = useOnclickOutside(() => {   
		clearSuggestions();
	});
	  
	const handleInput = (e) => {
    // Update the keyword of the input element
		setValue(e.target.value);	
		SetErrors({...errors,addressError: false});	
	};
  
   const handleSelect = ({ description }) => () => {
	setValue(description, false);
	//SetAppendAddress(description);
    clearSuggestions();
    // Get latitude and longitude via utility functions
    getGeocode({ address: description })
      .then((results) => getLatLng(results[0]))
      .then(({ lat, lng }) => {
       setCurrentLoc({
				 lat: lat,
				 lng: lng,
			   });
			   formattedAddress(lat,lng);
      })
      .catch((error) => {
        console.log("😱 Error: ", error);
      });
  };
  
   const renderSuggestions = () =>
    data.map((suggestion) => {
      const {
        place_id,
        structured_formatting: { main_text, secondary_text },
      } = suggestion;
      return (
        <li key={place_id} onClick={handleSelect(suggestion)}>
          <strong>{main_text}</strong> <small>{secondary_text}</small>
        </li>
      );
    });
	//Location AutoSearch Ends Here!
	function getAddressParts(obj) {
		const address = [];
	
		obj.address_components.forEach( function(el) {
			address[el.types[0]] = el.long_name;
		});	
		return address;	
	}
	const formattedAddress = (latitude,longitude) =>{
		axios.get('https://maps.googleapis.com/maps/api/geocode/json?latlng='+latitude+','+longitude+'&sensor=false&key=AIzaSyBmVMC0bF70GiUId2oDWXA3PTURgbacxYg'
		  )
		  .then(res => {
			  const resdata = res.data.results[0].address_components; 
			  
			  const addressParts =  getAddressParts(res.data.results[0]);
			  const city = addressParts.locality;			
			  const state = addressParts.administrative_area_level_1;
			  const country = addressParts.country;	
			  const postal_code = addressParts.postal_code;		
			
			setFormData({...formData,appendAddress:res.data.results[0].address_components[1].long_name+', '+res.data.results[0].address_components[2].long_name}); 
			  //console.log(state);	
			 // console.log(res.data.results[0].address_components[3]['long_name']);				
		  });
	}


	
	const submitHandler = (e)=>{
			e.preventDefault();
			if(enteredGarageName.current.value.trim().length===0){
				SetErrors({...errors, garageNameError: true});
				toast('Please enter Garage Name!');			 
				return;
			}else{
				SetErrors({...errors, garageNameError: false});
			}
			
			if(enteredEmail.current.value.trim().length===0){
				  SetErrors({...errors, emailError: true});
				  toast('Please enter Email!');
				 return;
			}else{
				SetErrors({...errors, emailError: false});
			}
			
			/*if(enteredGstNo.current.value.trim().length===0){
				  SetErrors({...errors, gstNumberError: false});
				  return;
			}else{
				SetErrors({...errors, gstNumberError: false});
			}*/
			
			if(enteredOwnerName.current.value.trim().length===0){
				  SetErrors({...errors, ownerNameError: true});
				  toast('Please enter Owner Name!');
				  return;
			}else{
				SetErrors({...errors, ownerNameError: false});
			}

			if(enteredMobile.current.value.trim().length===0){
				SetErrors({...errors, ownerMobileError: true});
				toast('Please enter Owner Mobile No.!');
				  return;				
			}

			if(enteredAddress.current.value.trim().length===0){
				SetErrors({...errors,addressError: true});	
				toast('Please enter Address.!');
				return;		
			}
			if(enteredState.current.value.trim().length===0){
				SetErrors({...errors,stateError: true});
				toast('Please select State.!');	
				return;		
			}
			if(enteredCity.current.value.trim().length===0){
				SetErrors({...errors,cityError: true});	
				toast('Please select City.!');
				return;		
			}
			if(enteredZipcode.current.value.trim().length===0){
				SetErrors({...errors,zipError: true});	
				toast('Please enter zipcode.!');
				return;		
			}
			
			/*if(gstExist===true){
				return;
			}
			if(customerExist===true){
				return;
			}*/
			if(mobileVerified===false && customerExist===false){
				toast("Please verify owner mobile no!");
				return;
			}
			
		
		const config = {
			  bucketName: S3_BUCKET_NAME,
			  dirName: 'garage_pictures', /* optional */
			  region: 'ap-south-1',
			  accessKeyId: 'AKIA2WD2BJFCHHBF42QB',
			  secretAccessKey: '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',
			  s3Url:'https://s3-ap-south-1.amazonaws.com/',
		}
		
		var imgStr = ''; 
		if(pictures.length>0){
			for (let i = 0; i < pictures.length; i++) {
				imgStr += pictures[i]['name']+',';
				S3FileUpload.uploadFile(pictures[i],config)
				.then((data)=>{
					console.log(data.location);	
				}).catch((err)=>{
					console.log(err);
				})
			  //formData.append("file[]", pictures[i]);
			}
		}
		
		//console.log(imgStr);
		
		const customerJson = {
			garageName : enteredGarageName.current.value,
			ownerName : enteredOwnerName.current.value,
			ownerMobile : enteredMobile.current.value,
			email : enteredEmail.current.value,
			managerName : enteredManagerName.current.value,
			managerMobile : enteredManagerMobile.current.value,
			gstNo : enteredGstNo.current.value,
			address : enteredAddress.current.value,
			landmark:enteredLandMark.current.value,
			country : 'India',
			state : enteredState.current.value,
			city : enteredCity.current.value,
			zipCode : enteredZipcode.current.value,
			geocode : enteredGeocode.current.value,
			garageArea : enteredGarageArea.current.value,
			numberOfBays : enteredBays.current.value,
			numberOfCars : enteredCars.current.value,
			oilConsumption : enteredOilConsumption.current.value,
			sparePurchases : enteredSparePurchase.current.value,
			bodyWorksPainting : bodyWorks,
			garageOilTie : garageOil,
			oilCompany:formData.oilCompanies,
			paintCompany:formData.paintCompanies,
			owner_share:enteredOwnerShare.current.value,
			manager_share:enteredManagerShare.current.value,
			imgList: imgStr
			
		};
		
		// console.log(customerJson);
		// return false;
		axios.post(API_URL+'pos/api/Customer',customerJson,{
		   auth: {username:'az_live@autozilla.com',
                  password:'4cslC166sb2A63FmO7Jh65z0N3Zh1ZL8'},
		  headers : {           
            'Content-Type' : 'application/json'
          }
		})
		.then(res => {
			if(res.data.userId>0){
				//console.log(res.data.userId);
				toast('Customer onboarded successfully!');
				//window.location.reload();
				setTimeout(function(){window.location.reload()} , 3000); 

			}else{
				toast(res.data.message);
			}	  
		});
		
		//console.log(JSON.stringify(customerJson));
	}
	if(sessionStorage.getItem('user_id')>0){
    return <Fragment>
	
   <div className='sign_up'>
		<div>   
		<ToastContainer autoClose={5000}/>          
			<form className='container'> 
				<div className='row'>
				<div className="col-sm-12">
				{/* SEction Start Here */}
				<div className='bg_m1'>
				<div className='row'>
				<div className="col-sm-12 gradent_m2">
					<h4 className='head_m1'>Personal Details</h4>	
				</div>
				<div className='col-sm-4'>
					<div className='input_m1'>
						<label>Name Of the Garage</label>
						<input type="text" onChange ={validateHandler} className = {`${ errors.garageNameError && classes.invalid}`} name ="garage_name" ref={enteredGarageName} value={formData.garage_Name}/>					
					</div>
				</div>
					 
				<div className='col-sm-4'>
					<div className='input_m1'> 
						<label>Email</label>
						<input type="email" onChange ={validateHandler} name="email" className = {`${ errors.emailError && classes.invalid}`} value ={formData.emailId} ref={enteredEmail} />
					</div>
				</div>
				
				<div className='col-sm-4'>
					<div className='input_m1'> 
						<label>GST Number</label>
						<input type="text" onChange ={validateGstHandler} name="gstno"  maxLength="15" className = {`${ errors.gstNumberError && classes.invalid}`} value={formData.gstNo} ref={enteredGstNo}/>
							{gstExist===true &&
								<p className='error_msg'>Customer already exist.</p>
							}
					</div>
				</div>
				
				<div className='col-sm-4'>
					<div className='input_m1'> 
						<label>Owner Name</label>
						<input type="text" onChange ={validateHandler} name="owner_name" className = {`${ errors.ownerNameError && classes.invalid}`} value={formData.owner_Name} ref={enteredOwnerName}/>
					</div>
				</div>
				<div className='col-sm-4 '>
					<div className='input_m1 input_m2'> 
						<label>Owner Mobile No.</label>
						<input type="text" onChange ={validateMobileNumber} pattern="[0-9]*" name="owner_mobile_no" maxLength="10" value={formData.mobileNo} className = {`${ errors.ownerMobileError && classes.invalid}`} ref={enteredMobile} required />
						{mobileValid ===false &&
							<p className='error_msg'>Please enter valid number</p>
						}
						{otpMatched ===false &&
							<p className='error_msg'>Please enter valid otp.</p>
						}
						{customerExist ===true &&
							<p className='error_msg'>Customer already exist.</p>
						}
						{ mobileVerified ===false &&
						<button onClick={verifyButtonHandler} className="btn_s1">Get OTP</button>
						}
						{mobileVerified=== true &&
						<span className="verified_text"><img src={VerifyIcon} /></span>
						}
					</div>
				</div>
				
				<div className='col-sm-4 otp_set'>
					{ showOtpInput===true &&				
						<div className='input_m1'> 
						<OTPInput
						  value={OTP}
						  onChange={setOTP}
						  autoFocus
						  OTPLength={4}
						  otpType="number"					
						   className='otp_main'
						/>
						<span className="otp_resend">
						<button onClick={verifyMobileHandler} className='otp_verify btn_s2 mt-1'>Verify</button>
						<ResendOTP onResendClick={(e) => resendOTP(e)} />
						
						</span>
						</div>
					}
					
				</div>
				 
				<div className="col-sm-12 clearfix"></div>
				<div className='col-sm-4'>
					<div className='input_m1'> 
						<label>Manager Name</label>
						<input type="text" name="manager_name"
						onChange={(e) =>								 
							setFormData({...formData,manager_Name:  e.target.value })
						  }  
						ref={enteredManagerName} 
						value={formData.manager_Name}/>
					</div>
				</div>

				<div className='col-sm-4'>
					<div className='input_m1'> 
						<label>Manager Mobile No.</label>
						<input type="text" name="manager_mobile_no" maxLength="10" 
						onChange={(e) =>								 
							setFormData({...formData,manager_Phone:  e.target.value })
						}  
						ref={enteredManagerMobile} 
						value={formData.manager_Phone}/>
					</div>
				</div>

				</div>
				</div>
				{/* SEction End Here */}
				

				{/* SEction Start Here */}
				<div className='bg_m1'>
				<div className='row'>
				<div className="col-sm-12 gradent_m2">
					<h4 className='head_m1'>Address Details</h4>	
				</div>
				<div className='col-sm-6'>
					<div className='row'>
						<div className='col-sm-12'>
							<div className='input_m1'> 
								<label>Address</label>							
								<textarea name ="address" value={formData.appendAddress}
								onChange ={addressChangeHandler}
								className = {`${ errors.addressError && classes.invalid}`} 								
								ref={enteredAddress} rows="1"></textarea>
							
							
							</div>
						</div>
						<div className='col-sm-12'>
							<div className='input_m1'> 
								<label>Land Mark</label>
								<input type="text" name="land_mark" 
								value={formData.land_Mark}
								onChange={(e) =>								 
									setFormData({...formData,land_Mark:  e.target.value })
								} 
								ref={enteredLandMark} />
							</div>
						</div>
						<div className='col-sm-12'>
							<div className='input_m1'> 
								<label>State</label>
								<select onChange={(e)=>stateSelectHandler(e,e.target.value)} ref={enteredState} value={formData.stateId}>
									{states.map((state) => (
									<option key={state.state_id} value={state.state_id}>{state.state}</option>
									))}						
								</select>
							</div>
						</div>

						<div className='col-sm-12'>
							<div className='input_m1'> 
								<label>City</label>
								<select ref={enteredCity} value={formData.cityId}
								className = {`${ errors.cityError && classes.invalid}`}
								onChange={(e)=>citySelectHandler(e,e.target.value)} >
								{cities.map((city) => (
									<option key ={city.city_id} value={city.city_id}>{city.city}</option>
									))}
								</select>
							</div>
						</div>
						<div className='col-sm-12'>
							<div className='input_m1'> 
								<label>Zip Code</label>
								<input type="text" name="zipcode" 
								maxLength={6} pattern="[0-9]*" 
								value={formData.postcode}
								ref={enteredZipcode} onChange={validateHandler}
								className = {`${ errors.zipError && classes.invalid}`}/>
							</div>
						</div>
					</div>
				</div>

					<div className='col-sm-6'>						 
						<div className='input_m1'> 
							<label>Lat/Longitude</label>						 
							<input type="text" name="geocode" value={currentLoc.lat+', '+currentLoc.lng} ref={enteredGeocode}/>
						</div>			

							<div className='input_m1'> 
								<div ref={ref}>
									<input type="text" 
									name="serach_address" 
									placeholder="Search address here.."
									value={value} 
									onChange={handleInput} />
								{status === "OK" && <ul>{renderSuggestions()}</ul>}
								</div>
							</div>	

						  <GoogleMap
							mapContainerStyle={containerStyle}
							center={{ lat: currentLoc.lat, lng: currentLoc.lng }}
							zoom={15}						
						  >
							{/* Child components, such as markers, info windows, etc. */}
							 <Marker
								position={currentLoc}
							  >									
							  </Marker>
						  </GoogleMap>
						
					</div>				
				</div>					 
				</div>
				{/* SEction End Here */}
			

				{/* SEction Start Here */}
				<div className='bg_m1'>
					<div className='row'>
						<div className="col-sm-12 gradent_m2">
							<h4 className='head_m1'>Workshop Details</h4>	
						</div>
						<div className='col-sm-4 col-md-3'>
							<div className='input_m1'> 
								<label>Area of the Garage(sq ft)</label>
								<input type="text" 
								name="garage_area" 
								value={formData.garage_Area} 
								onChange={(e) =>								 
									setFormData({...formData,garage_Area:  e.target.value })
								  } 
								ref={enteredGarageArea} />
							</div>
						</div>
						<div className='col-sm-4 col-md-3'>
							<div className='input_m1'> 
								<label>Number of Bays</label>
								<input type="text" name="noof_bays" 
								value={formData.bays_Number} 
								onChange={(e) =>								 
									setFormData({...formData,bays_Number:  e.target.value })
								  } 
								ref={enteredBays} />
							</div>
						</div>

						<div className='col-sm-4 col-md-3'>
							<div className='input_m1'> 
								<label>Number of Cars / Month</label>
								<input type="text" 
								pattern="[0-9]*" 
								value={formData.noCarsVal} 
								onChange={(e) =>								 
								  setFormData({...formData,noCarsVal: e.target.validity.valid ? e.target.value : ''})
								} 
								name="noof_cars" 
								ref= {enteredCars} 
								/>
							</div>
						</div>					
						<div className='col-sm-4 col-md-3'>
							<div className='input_m1'> 
								<label>Oil consumption(Lts)</label>
								<input type="text" name="oil_consumption" 
								value={formData.oil_Consumption}
								onChange={(e) =>								 
									setFormData({...formData,oil_Consumption:  e.target.value })
								  } 
								ref={enteredOilConsumption} />
							</div>
						</div>
						<div className='col-sm-4 col-md-3'>
							<div className='input_m1'> 
								<label>Total Spare Purchases</label>
								<input type="text" pattern="[0-9]*" 
								value={formData.sparePurVal} 
								onChange={(e) =>								 
									setFormData({...formData,sparePurVal: e.target.validity.valid ? e.target.value : ''})
								  } 
								name="spare_sales" 
								ref={enteredSparePurchase} />
							</div>
						</div>
					
					</div>
				</div>
			{/* SEction End Here */}

			{/* SEction Start Here */}
				<div className='bg_m1'>
					<div className='row'>
						<div className="col-sm-12 gradent_m2">
						<h4 className='head_m1'>Partnership</h4>	
					</div>
					
					<div className='col-sm-4 col-md-3'>
						<div className='toggle_btn1'> 
							<label>Garage Oil Tie Up</label>
							<div className='selector'>
								<div className='selecotr-item'>
									<input type="radio" id="oil_tie_yes" name="garage_oil_tie" className='selector-item_radio' onChange={garageOilChangeHandler} value='Yes'  checked={garageOil=='Yes'}/>
									<label htmlFor="oil_tie_yes" className='selector-item_label'>Yes</label>
								</div>
								<div className='selecotr-item'>
									<input type="radio" id="oil_tie_no" name="garage_oil_tie" className='selector-item_radio' onChange={garageOilChangeHandler} value='No' checked={garageOil =='No'}/>
									<label htmlFor="oil_tie_no" className='selector-item_label'>No</label>
								</div>
								
							</div>
						</div>
					</div>
					
					{ garageOil === 'Yes' &&
					<div className='col-sm-4 col-md-3'>
						<div className='input_m1'> 
							<label>Oil Company</label>
							<input type="text" name="oil_company" onChange={enteredOilCompanyHandler} value={formData.oilCompanies} />
						</div>
					</div>
					}
					<div className='col-sm-12'></div>
					
					<div className='col-sm-4 col-md-3'>
						<div className='toggle_btn1'> 
							<label>Body works & Painting</label>                     
							<div className='selector'>
								<div className='selecotr-item'>
									<input type="radio" id="body_paint_yes" name="body_works" className='selector-item_radio' onChange={bodyworksChangeHandler} value='Yes'  checked={bodyWorks=='Yes'}/>
									<label htmlFor="body_paint_yes" className='selector-item_label'>Yes</label>
								</div>	
								<div className='selecotr-item'>
									<input type="radio" id="body_paint_no" name="body_works" className='selector-item_radio' onChange={bodyworksChangeHandler} value='No' checked={bodyWorks=='No'}/>
									<label htmlFor="body_paint_no" className='selector-item_label'>No</label>
								</div>

							</div>
						</div>
					</div>
					
					{ bodyWorks === 'Yes' &&
					<div className='col-sm-4 col-md-3'>
						<div className='input_m1'> 
							<label>Painting Company</label>
							<input type="text" name="paint_company" onChange={PaintCompanyHandler} value={formData.paintCompanies} />
						</div>
					</div>
					}
						
					</div>
				</div>
					
					
			{/* SEction End Here */}		

				{/* SEction Start Here */}
				<div className='bg_m1'>
					<div className='row'>
						<div className="col-sm-12 gradent_m2">
							<h4 className='head_m1'>Autozilla Rewards</h4>	
						</div>
						<div className='col-sm-4 col-md-3'>
							<div className='input_m1'> 
								<label>Owners Share</label>
								<input type="number" name="owner_share" min="0"
								ref={enteredOwnerShare}
								 onChange={ownerShareChangeHandler} 
								 value={formData.owner_Share}
								 max="100" />
							</div>
						</div>
						<div className='col-sm-4 col-md-3'>
							<div className='input_m1'> 
								<label>Manager Share</label>
								<input type="number" name="manager_share" min="0"
								ref={enteredManagerShare} 
								value={formData.managerShare}
								max="100" />
							</div>
						</div>
					
					</div>
				</div>
			{/* SEction End Here */}


				{/* SEction Start Here */}
				<div className='bg_m1'>
					<div className='row'>
						<div className="col-sm-12 gradent_m2">
							<h4 className='head_m1'>Workshop Images</h4>	
						</div>
						{/*<div className='col-sm-4'>
							<div className='input_m1'> 
								<label>Bank Details</label>
								<textarea name ="bank_details"></textarea>
							</div>
						</div>*/}

						<div className='col-sm-12'>
							<div className='garage_up'>
								<label>Garage Pictures</label>
								<div className="upload-btn-wrapper">
									<button className="btn"><i className="fa fa-plus-circle" aria-hidden="true"></i></button>
									<input type="file" multiple onChange ={filesSelectHandler}/>
								</div>
							</div>
							<div className='garage_pics'>								
								<div className = {classes.image_box}>
										{pictures.map((img,i) => (
											<div className="upload_result" key={i}>
												<i className="fa fa-times-circle" aria-hidden="true" onClick={() => deleteImage(img.name)} ></i>
												<img className={classes.img_preview} src={URL.createObjectURL(img)} key={i} />
											</div>
										))}										
								</div>
							</div>
							
							{/*<div className='input_m1'> 
									<label>Garage Pictures</label>
									<input type="file" name="garage_pictures" onChange ={filesSelectHandler}/>
						
								</div>*/}
						</div>
					</div>
				</div>
				{/* SEction End Here */}				

				<div className='col-sm-12 text-center mt-5 mb-5'>
					<button className="btn btn_m1" onClick={submitHandler}>Onboard Customer</button>
				</div>
			</div>
			</div>
			</form>
		</div>
		<div className="right_set">
		<img src={BottomBgm} />
		</div>
	</div>
	
</Fragment>
	}else{
		return (           
			<div className={classes.mainLogin}>
				<div className="container-fluid">
				<div className="row  mt-5">
					<div className="col-sm-4 offset-sm-4 mt-4 mb-4">
			<img src= {AuthLogo} alt='Auto Parts By Autozilla' className="w-100"/>
			<p className="mt-3 text-center"><b>Authentication Required to access the Catalog</b></p>
			</div>
			</div>
			</div>                    
			</div>    
			
			
		);
	}
}

export default CustomerForm;